import { render } from "./FileInputWithEdit.vue?vue&type=template&id=dab4dca6"
import script from "./FileInputWithEdit.vue?vue&type=script&lang=js"
export * from "./FileInputWithEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__